// Mock data for Tymur Abkiliamov's Data Science Portfolio

export const mockData = {
  personal: {
    name: "Tymur Abkiliamov",
    title: "Senior Data Scientist",
    subtitle: "Transforming data into actionable insights",
    location: "Chemnitz / Zwickau, Germany",
    email: "tymarbeit@gmail.com",
    emailSecondary: "tymur@abkiliamov.com",
    linkedin: "https://www.linkedin.com/in/tymur-abkiliamov-0324a637a/",
    // github: "https://github.com/tabkiliamov",
    // twitter: "https://twitter.com/tabkiliamov",
    profileImage: "/images/tymur-profile.jpg"
  },

  skills: {
    programming: [
      "Python", "C++", "SQL", "C#", "Java"
    ],
  
    libraries: {
      "Data Science Core": [
        "Pandas", "NumPy", "SciPy", "Scikit-learn"
      ],
      "Visualization": [
        "Matplotlib", "Seaborn", "Plotly", "Bokeh", "Altair"
      ],
      "Deep Learning": [
        "TensorFlow", "Keras", "PyTorch", "Lightning", "Hugging Face Transformers"
      ],
      "Computer Vision": [
        "OpenCV", "TorchVision", "Albumentations", "MMCV"
      ],
      "NLP": [
        "NLTK", "spaCy", "Gensim", "Hugging Face Datasets"
      ],
      "Time Series": [
        "Statsmodels", "Prophet", "tsfresh", "Kats"
      ],
      "Big Data": [
        "PySpark", "Dask", "Vaex", "Ray"
      ],
      "MLOps": [
        "MLflow", "Kubeflow", "Weights & Biases", "TensorBoard", "Optuna"
      ],
      "AutoML & Optimization": [
        "Optuna", "Ray Tune", "Auto-sklearn", "TPOT"
      ],
      "Advanced Models": [
        "XGBoost", "LightGBM", "CatBoost", "Faiss", "Annoy"
      ]
    },
  
    tools: [
      "Jupyter", "Docker", "Git", "AWS", "GCP", "Databricks"
    ],
  
    databases: [
      "PostgreSQL", "MongoDB", "Redis", "Snowflake", "BigQuery",
      "SQLAlchemy", "Polars", "DuckDB", "PyArrow"
    ],
  
    visualization: [
      "Tableau", "Power BI"  // BI-инструменты, не пересекаются с кодовыми либами
    ]
  },

  experience: [
    {
      id: 1,
      translationKey: "tki",
      company: "Tele-Kabel-Ingenieurgesellschaft mbH",
      position: "AI Developer in Research Group",
      duration: "March 2024 - Present",
      location: "Germany",
      status: "Current",
      description: "Developed and deployed AI models for object detection, segmentation, and classification using YOLO models by Ultralytics. Main responsibilities included custom training of YOLOv8 segmentation models using PyTorch and Ultralytics, handling large-scale datasets and annotations (over 10,000 labeled images), training on remote GPU servers for performance and scalability, hyperparameter tuning, augmentation pipelines, and evaluation, integration of detection models into production-level systems. Also worked with visualization tools and experiment tracking platforms (e.g., Neptune.ai) to monitor training performance in real time.",
      tags: ["AI", "YOLOv8 - v11", "Ultralytics", "PyTorch", "Object Detection", "Segmentation", "GPU Training", "Model Optimization", "Experiment Tracking"],
      achievements: [
        "Custom training of YOLOv8 segmentation models using PyTorch and Ultralytics",
        "Handled large-scale datasets with over 10,000 labeled images",
        "Implemented GPU training on remote servers for performance and scalability",
        "Integrated detection models into production-level systems",
        "Used experiment tracking platforms (Neptune.ai) for real-time performance monitoring"
      ]
    },
    {
      id: 2,
      translationKey: "intraclass",
      company: "Intraclass GmbH",
      position: "Frontend Developer and Designer",
      duration: "March 2024 - May 2025",
      location: "Germany",
      status: "Completed",
      description: "Worked extensively on the Intraclass website built on Squarespace, managing multiple projects that enhanced user experience and business performance. Key achievements included developing and deploying custom JavaScript blocks to enhance website functionality, implementing SEO strategies that significantly improved product visibility and increased sales, creating engaging promotional posters and graphics using Canva, configuring and managing the student database, including secure login and password systems, setting up automated discount systems and streamlined purchase and sales processes to improve operational efficiency, maintaining and optimizing website performance, contributing to higher user engagement and conversion rates.",
      tags: ["HTML", "CSS", "JavaScript", "Squarespace", "E-commerce", "SEO", "Web Development", "Web Design", "Database Management", "Automation"],
      achievements: [
        "Developed custom JavaScript blocks to enhance website functionality",
        "Implemented SEO strategies that significantly improved product visibility and increased sales",
        "Created engaging promotional materials and graphics using Canva",
        "Configured and managed student database with secure login systems",
        "Set up automated discount systems and streamlined purchase processes"
      ]
    },
    {
      id: 3,
      translationKey: "devart",
      company: "Devart",
      position: "Software Tester",
      duration: "March 2021 - February 2022",
      location: "Remote",
      status: "Completed",
      description: "Tested new programs and applications, ensuring functionality and quality before release. Worked on quality assurance processes and testing methodologies to maintain high standards of software reliability.",
      tags: ["Testing", "Quality Assurance", "Software Testing", "QA Processes"],
      achievements: [
        "Tested new programs and applications for functionality and quality",
        "Ensured software reliability before release",
        "Implemented quality assurance processes",
        "Maintained high standards of software testing"
      ]
    },
    {
      id: 4,
      translationKey: "programace",
      company: "Program-Ace",
      position: "Freelancer",
      duration: "May 2021 - February 2022",
      location: "Remote",
      status: "Completed",
      description: "Worked on various projects as a freelancer, delivering customized solutions to clients. Provided flexible development services and project management for diverse client needs.",
      tags: ["Freelancing", "Project Development", "Client Services", "Custom Solutions"],
      achievements: [
        "Delivered customized solutions to various clients",
        "Managed multiple freelance projects simultaneously",
        "Provided flexible development services",
        "Built strong client relationships"
      ]
    },
    {
      id: 5,
      translationKey: "travelagency",
      company: "Travel Agency 'Pora po stranam Ukraine'",
      position: "Website Administrator",
      duration: "December 2019 - June 2021",
      location: "Ukraine",
      status: "Completed",
      description: "Managed the agency's website on the Weblium platform, ensuring up-to-date content and smooth functionality. Responsible for content updates, website maintenance, and user experience optimization.",
      tags: ["Web Management", "Content Updates", "Weblium Platform", "Website Administration"],
      achievements: [
        "Managed agency website on Weblium platform",
        "Ensured up-to-date content and smooth functionality",
        "Optimized user experience and website performance",
        "Maintained website security and reliability"
      ]
    },
    {
      id: 6,
      translationKey: "tutoring",
      company: "Private Tutoring",
      position: "Math/Programming Tutor",
      duration: "2019 - 2022",
      location: "Ukraine",
      status: "Completed",
      description: "Taught mathematics and programming (Python/C++/Pascal) to children and teenagers, both individually and in groups. Developed customized learning materials and teaching methodologies to help students achieve their academic goals.",
      tags: ["Teaching", "Python", "C++", "Pascal", "Mathematics", "Programming Education", "Private Tutoring"],
      achievements: [
        "Taught mathematics and programming to children and teenagers",
        "Developed customized learning materials",
        "Conducted both individual and group sessions",
        "Helped students achieve academic success in programming and math"
      ]
    }
  ],

  projects: [
    {
      id: 1,
      translationKey: "bubbleshooter",
      title: "Bubble Shooter - iOS Game",
      description: "A polished, addictive Bubble Shooter game for iPhone and iPad built with Swift and SpriteKit. Features classic gameplay with hexagonal grid, endless mode with progressive difficulty, aim prediction with wall bounce visualization, combo system with score multipliers, and haptic feedback for satisfying game feel.",
      image: "/images/bubbleshooter-logo.png",
      imageBgColor: "#2d1b4e",
      imageContain: true,
      imageOptimized: {
        src: "/images/bubbleshooter-logo.png",
        alt: "Bubble Shooter - iOS Game",
        loading: "lazy",
        placeholder: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMWExMDM1Ii8+PC9zdmc+"
      },
      tags: ["Swift", "SpriteKit", "iOS", "Game Development", "Physics", "iPad"],
      github: "https://github.com/deeplearnproger/BubbleShooter",
      demo: null,
      aboutPage: "/bubbleshooter",
      privacyPolicy: "/bubbleshooter-privacy",
      featured: true,
      performance: {
        loadTime: "0.3s",
        bundleSize: "15MB",
        optimization: "60 FPS gameplay, efficient collision detection"
      },
      achievements: [
        "Classic Bubble Shooter gameplay with hexagonal grid",
        "Aim prediction with wall bounce visualization",
        "Combo system with score multipliers",
        "Floating cluster detection for bonus points",
        "Universal app for iPhone and iPad"
      ]
    },
    {
      id: 3,
      translationKey: "sprachmeister",
      title: "SprachMeister - AI German Learning App",
      description: "iOS app for practicing German language skills through AI-powered conversations and writing exercises. Features real-time speech recognition, natural text-to-speech responses, detailed metrics (WPM, filler words, grammar analysis), and writing practice with AI feedback. Built with SwiftUI and on-device speech processing for privacy.",
      image: "/images/sprachmeister-logo.png",
      imageOptimized: {
        src: "/images/sprachmeister-logo.png",
        alt: "SprachMeister - AI German Learning App for iOS",
        loading: "lazy",
        placeholder: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMWUzYThhIi8+PC9zdmc+"
      },
      tags: ["Swift", "SwiftUI", "iOS", "Speech Recognition", "AI", "Language Learning", "TTS", "NLP"],
      github: "https://github.com/deeplearnproger/sprachmeister",
      demo: null,
      aboutPage: "/sprachmeister",
      privacyPolicy: "/sprachmeister-privacy",
      featured: true,
      performance: {
        loadTime: "0.5s",
        bundleSize: "25MB",
        optimization: "On-device speech processing, offline functionality"
      },
      achievements: [
        "Real-time German speech recognition with on-device processing",
        "AI-powered conversation practice with Goethe B1 exam scenarios",
        "Detailed speaking metrics: WPM, filler words, grammar analysis",
        "Writing practice with grammar, style, and vocabulary feedback",
        "Fully offline speech processing for privacy and security"
      ]
    },
    {
      id: 4,
      translationKey: "octoaipus",
      title: "OctoAIpus - AI X-ray Diagnosis",
      description: "Revolutionary AI-powered chest X-ray analysis platform that provides instant pneumonia detection with 94.7% accuracy. Users can upload chest X-rays and receive immediate AI-powered insights, including heatmap visualization of affected areas. Trained on 1M+ X-ray scans, serving 75K+ global users.",
      image: "/images/octoaipus-preview.svg",
      imageOptimized: {
        src: "/images/octoaipus-preview.svg",
        alt: "OctoAIpus AI X-ray Diagnosis Platform - Chest X-ray Analysis with AI Heatmap",
        loading: "lazy",
        placeholder: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMGYxNzJhIi8+PC9zdmc+"
      },
      tags: ["Python", "TensorFlow", "Computer Vision", "Medical AI", "Deep Learning", "Healthcare"],
      github: "https://github.com/tabkiliamov/octoaipus",
      demo: "https://www.octoaipus.com",
      featured: true,
      performance: {
        loadTime: "1.8s",
        bundleSize: "2.1MB",
        optimization: "Medical-grade security, HIPAA compliant"
      },
      achievements: [
        "94.7% diagnosis accuracy on chest X-rays",
        "1M+ scans analyzed with 75K+ global users",
        "Real-time AI analysis in under 5 seconds",
        "Heatmap visualization of affected lung areas",
        "Free, private, and secure medical diagnosis"
      ]
    },
    {
      id: 5,
      translationKey: "coinsscan",
      title: "CoinsScan - AI Coin Recognition App",
      description: "Mobile application for automatic coin counting and numismatic value detection using computer vision. Users can scan piles of coins to instantly count them and identify valuable collectible coins. Features real-time recognition of 50+ currencies and historical coin databases.",
      image: "/images/coinsscan-logo.jpg",
      imageOptimized: {
        src: "/images/coinsscan-logo.jpg",
        alt: "CoinsScan - AI Coin Recognition App",
        loading: "lazy",
        placeholder: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMWU0MGFmIi8+PC9zdmc+"
      },
      tags: ["React Native", "Computer Vision", "TensorFlow Lite", "Mobile AI", "Numismatics", "Currency Recognition"],
      github: "https://github.com/tabkiliamov/coinsscan",
      demo: "https://coinsscan.app",
      featured: true,
      performance: {
        loadTime: "0.8s",
        bundleSize: "15MB",
        optimization: "TensorFlow Lite, offline processing"
      },
      achievements: [
        "95% accuracy in coin recognition across 50+ currencies",
        "Real-time processing with 0.2s average scan time",
        "Offline functionality with 15MB lightweight model",
        "Numismatic database with 10,000+ historical coins",
        "Multi-language support for global coin identification"
      ]
    },
    {
      id: 6,
      translationKey: "covid",
      title: "COVID-19 Spread Prediction Model",
      description: "Deep learning model predicting COVID-19 case trends using epidemiological data, achieving 92% accuracy across 50+ countries. Built with LSTM networks and real-time data integration.",
      image: "https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?w=600&h=400&fit=crop&auto=format&q=80",
      imageOptimized: {
        src: "https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?w=600&h=400&fit=crop&auto=format&q=80",
        alt: "COVID-19 Spread Prediction Model",
        loading: "lazy",
        placeholder: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjNmNGY2Ii8+PC9zdmc+"
      },
      tags: ["Python", "TensorFlow", "Pandas", "Time Series", "LSTM"],
      github: "https://github.com/tabkiliamov/covid-prediction",
      demo: "https://covid-predict.herokuapp.com",
      featured: false,
      performance: {
        loadTime: "2.3s",
        bundleSize: "1.2MB",
        optimization: "WebP format, lazy loading"
      }
    },
    {
      id: 7,
      translationKey: "sentiment",
      title: "NLP Sentiment Analysis Platform",
      description: "Real-time sentiment analysis system for social media data processing 1M+ tweets daily with 89% accuracy using transformer models. Includes dashboard and API endpoints.",
      image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=600&h=400&fit=crop&auto=format&q=80",
      tags: ["Python", "BERT", "PyTorch", "AWS", "Docker", "FastAPI"],
      github: "https://github.com/tabkiliamov/sentiment-nlp",
      demo: "https://sentiment-analyzer.com",
      featured: false
    },
    {
      id: 8,
      translationKey: "ecommerce",
      title: "E-commerce Recommendation Engine",
      description: "Collaborative filtering system for personalized product recommendations, increasing click-through rates by 35%. Features real-time updates and A/B testing framework.",
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop&auto=format&q=80",
      tags: ["Python", "Scikit-learn", "Redis", "Flask", "Matrix Factorization"],
      github: "https://github.com/tabkiliamov/recommendation-engine",
      demo: "https://recommendations-demo.vercel.app",
      featured: false
    },
    {
      id: 9,
      translationKey: "financial",
      title: "Financial Market Predictor",
      description: "LSTM-based model for stock price prediction using technical indicators and market sentiment data. Achieves 78% accuracy on S&P 500 stocks.",
      image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&h=400&fit=crop&auto=format&q=80",
      tags: ["Python", "LSTM", "Pandas", "Alpha Vantage API", "Technical Analysis"],
      github: "https://github.com/tabkiliamov/stock-predictor",
      demo: "https://stock-predictor.streamlit.app",
      featured: false
    },
    {
      id: 10,
      translationKey: "objectdetection",
      title: "Computer Vision Object Detection",
      description: "YOLO-based object detection system for real-time video analysis. Optimized for mobile deployment with 60fps performance on edge devices.",
      image: "https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=600&h=400&fit=crop&auto=format&q=80",
      tags: ["Python", "OpenCV", "YOLO", "TensorFlow", "Mobile", "Edge Computing"],
      github: "https://github.com/tabkiliamov/object-detection",
      demo: "https://object-detection-demo.herokuapp.com",
      featured: false
    },
    {
      id: 11,
      translationKey: "churn",
      title: "Customer Churn Prediction",
      description: "Machine learning model predicting customer churn with 85% accuracy. Includes feature engineering pipeline and model interpretability tools.",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop&auto=format&q=80",
      tags: ["Python", "XGBoost", "SHAP", "Pandas", "Customer Analytics"],
      github: "https://github.com/tabkiliamov/churn-prediction",
      featured: false
    }
  ],

  education: [
    {
      translationKey: "datascience",
      degree: "Bachelor's in Data Science",
      school: "WHZ – University of Applied Sciences Zwickau",
      year: "2022 - 2026 (Expected)",
      focus: "Data Science, Machine Learning & AI",
      status: "In Progress (7th Semester)",
      description: "Currently pursuing a Bachelor's degree in Data Science at WHZ. The curriculum focuses on data analysis, machine learning, deep learning, and statistical modeling, with hands-on experience through academic projects and research.",
      tags: ["Data Science", "Machine Learning", "Deep Learning", "Computer Vision", "Statistical Modeling", "Python", "AI Research", "Big Data", "Algorithms", "Data Analytics"]
    },
    {
      translationKey: "automotive",
      degree: "Bachelor's in Automobile Transport and Vehicle Engineering",
      school: "NTU KhPI – National Technical University 'Kharkiv Polytechnic Institute'",
      year: "2021 - 2025",
      focus: "Automotive Engineering & Transport Analytics",
      status: "Completed",
      description: "Completed a Bachelor's degree in Automobile Transport at NTU KhPI, specializing in vehicle design, automotive components, internal combustion engines, and diagnostics. The curriculum focused on the construction and operation of vehicles, technical maintenance, and the analysis of mechanical systems for safe and efficient transport solutions.",
      tags: ["Vehicle Design", "Automotive Components", "Engine Technology", "Vehicle Diagnostics", "Mechanical Systems", "Automotive Engineering", "Transport Analytics", "Statistical Analysis", "Automotive Business", "Traffic Safety", "Logistics"]
    }
  ],

  certifications: [
    "AWS Certified Machine Learning - Specialty",
    "Google Cloud Professional Data Engineer",
    "TensorFlow Developer Certificate",
    "Microsoft Azure AI Engineer Associate",
    "Databricks Certified Data Engineer",
    "Certified Analytics Professional (CAP)"
  ],

  achievements: [
    "Published 3 research papers in top-tier ML conferences",
    "Led team of 8 engineers on ML infrastructure projects",
    "Increased model accuracy by 25% through feature engineering",
    "Reduced model inference time by 60% through optimization",
    "Mentored 15+ junior data scientists and ML engineers"
  ],

  languages: [
    { name: "English", level: "Native" },
    { name: "Russian", level: "Native" },
    { name: "Spanish", level: "Conversational" },
    { name: "French", level: "Basic" }
  ]
};

// Mock API functions
export const mockAPI = {
  getProjects: () => Promise.resolve(mockData.projects),
  getFeaturedProjects: () => Promise.resolve(mockData.projects.filter(p => p.featured)),
  getExperience: () => Promise.resolve(mockData.experience),
  getSkills: () => Promise.resolve(mockData.skills),
  sendMessage: (message) => {
    console.log('Mock API: Message sent', message);
    return Promise.resolve({ success: true, message: 'Message sent successfully!' });
  }
};